import React, { ComponentProps, useState } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { AttributeGroupInfoRules } from '../partials/AttributeGroupInfoRules';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { BlockBar, BlockBarButton } from '../../../_lib/components/BlockBar';
import { Icons } from '../../../components/atoms/SVG';
import ModalDialog from '../../../components/organisms/ModalDialog/ModalDialog';
import { AttributeGroupForm } from '../forms/AttributeGroupForm';
import { SonForm } from '../../../_lib/Form2';
import { ModalDialogModifier } from '../../../components/organisms/ModalDialog/ModalDialog';

type AttributeGroupInfoEditViewProps = AttributeGroupInfoRules & { edit: SonForm<any> };

function AttributeGroupInfoEdit({ rules, ruleCombination, edit }: AttributeGroupInfoEditViewProps) {
  const { t } = useSonTranslation('AttributeGroups');
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <>
      <BlockBar heading={t('editRulesInThisGroup')} hierarchy={3}>
        <BlockBarButton onClick={() => setModalOpen(true)} text={t('editRules')} svgSpriteId={Icons.EDIT_PENCIL} />
      </BlockBar>
      <AttributeGroupInfoRules rules={rules} ruleCombination={ruleCombination} />
      {modalOpen && (
        <ModalDialog
          modifier={ModalDialogModifier.WIDE}
          closeModal={() => setModalOpen(false)}
          headline={t('editRules')}
          initialFocusIndex={1}
        >
          <AttributeGroupForm form={edit} />
        </ModalDialog>
      )}
    </>
  );
}

export const AttributeGroupInfoEditView = asView(AttributeGroupInfoEdit);
export type AttributeGroupInfoEditView = ComponentProps<typeof AttributeGroupInfoEditView>;
